import PATHS from '../../routes/routes.const';

export class TargetPaths {
  static list(): string {
    return PATHS.main.targets.list.path;
  }

  static detail(targetId: string): string {
    return PATHS.main.targets.form.path.replace(':targetId', targetId);
  }
}
